import React, { Component } from 'react';
import {NavLink, Link} from "react-router-dom";
import Footer from "../Components/footer";
import  Header  from "../Components/header";
import DataTable from "../Components/datatablepublisher";
import { RedirectNotLogin, AlertMessageOut, getSession, UpdateState, AlertMessage, clearSession, getState } from "../Components/function";
import FingerprintJS from '@fingerprintjs/fingerprintjs';
import * as axios from 'axios';
import $ from "jquery";
import { ApiEndpoint, name, platform } from '../Constant';

// Initialize an agent at application startup.
const fpPromise = FingerprintJS.load();

export const FingerPrint = async (type = 'visitor') => {
// Get the visitor identifier when you need it.
const fp = await fpPromise;
const result = await fp.get();

// This is the visitor identifier:
if(type === 'visitor'){
 return result.visitorId;
}
else{
  //return result.visitorId;
}
}


class Editors extends Component{

  constructor(props){
    super(props);
    
    this.state = {
      data: [],
      message: '',
    }

    }
    
    componentDidMount(){
      RedirectNotLogin();
      var that = this;
      this.loadDataFromServer();
    }

    componentDidUpdate() {
      RedirectNotLogin();
    }

    componentWillReceiveProps(newProps){
      RedirectNotLogin();
    }

    AlertNoTableData = () => {
        return <div><div className='p15 center block'>There are no Editor on your field at the moment, do check back later - No Result found!</div></div>;
      }

    loadDataFromServer = async () => {
        
        UpdateState(this, 'loading', '1');

        let DeviceSid = await FingerPrint();

        let header = {
            headers : {
                'Accept': 'application/json',
                'Content-Type': "application/x-www-form-urlencoded",
                'Authorization': "Bearer " + getSession('token') + ", Session " + DeviceSid + ", Platform "+ platform,
                'My-Custom-Header': name,
                'User-Agent': name+ " Bot",
               }
         };

         let datas = new URLSearchParams({
            command: 'fetch',
            cmd: 'editors',
            user_id: getSession('userID'),
        }).toString();
         
           axios.get(ApiEndpoint+"/fetchResult?"+datas, header)
           .then(response => {
           
            UpdateState(this, 'loading', '0');

            if(response.data.retry == true){
             let retryTimes = getState(this, 'retry_times') >= 0 && getState(this, 'retry_times') != '' ? getState(this, 'retry_times') : ''; 
             if(retryTimes != ''){
             if(getState(this, 'retry_times') < 15){
              setTimeout(function(){
             UpdateState(this, 'retry_times', getState(this, 'retry_times') + 1);
             this.loadDataFromServer();
              }, 4000);
             }
             }
           }
      
          if(response.data.error == false && response.data.error != true){
      
          UpdateState(this, 'data', response.data.data.length > 0 ? response.data.data : []);
          UpdateState(this, 'message', '');
          UpdateState(this, 'loading', '0');
       
          }
          else if(response.data.error != false){
            AlertMessage(this, response.data.error, 'error');
            UpdateState(this, 'loading', '0');
            if(response.data.logout == true && response.data.token == false){
              setTimeout(function(){
              clearSession();
              window.location.href = "/login";
              }, 4000);
              }
          }
          else{
            UpdateState(this, 'loading', '0');
            AlertMessage(this, "Something went wrong, try again or try to reload the page!", 'error');
          }
        }).catch(err => {
           UpdateState(this, 'loading', '0');
            AlertMessage(this, "Something went wrong, try again or try to reload the page!\n\r"+err, 'error');
            let retryTimes = getState(this, 'retry_times') >= 0 && getState(this, 'retry_times') != '' ? getState(this, 'retry_times') : ''; 
             if(retryTimes != ''){
             if(getState(this, 'retry_times') < 15){
              setTimeout(function(){
             UpdateState(this, 'retry_times', getState(this, 'retry_times') + 1);
             this.loadDataFromServer();
              }, 4000);
             }
             }
        });
      }
 
  render(){
    return (
        <div className="App AppWrap">
    
    <Header self={this}/>
    

    <div className="App iBG dash-dash-full">
    <div className="containers">
   
    <div className="card-lt-wrap ml0">
    <div className="card-lt breadcrumb">
  <h1><NavLink to="/dashboard">Dashboard</NavLink> <i className="fa fa-chevron-right"></i> <NavLink to="/editors">Editors</NavLink> <i className="fa fa-chevron-right"></i> {getSession('division')}</h1>
  </div>
  </div>

  <div className="card-lt-wrap ml0">
    <div className="card-lt">
     
     {AlertMessageOut(this)}

     {getState(this, 'data')?.length == 0 ? this.AlertNoTableData() : ''}
     {getState(this, 'data')?.map((editors, i) => {
        
   return(<>
      <div className="btn-lt tiny-lt" key={i}>
      
        <div className="btn-text-lt">
        {editors['title']} {editors['name']}
        </div>
        </div>
        </>);
     })}
        
    
     </div>

        <Footer classX="dash-footer"/>

    </div>
    
    </div>

    </div>

    </div>
    );
}

}

export default Editors;